import { render, staticRenderFns } from "./shippingpolicy.vue?vue&type=template&id=5118a9ed&"
import script from "./shippingpolicy.vue?vue&type=script&lang=js&"
export * from "./shippingpolicy.vue?vue&type=script&lang=js&"
import style0 from "./shippingpolicy.vue?vue&type=style&index=0&id=5118a9ed&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PolicyContent: require('/opt/atlassian/pipelines/agent/build/components/PolicyContent.vue').default})
